(function(root){
  const normalize=value=>String(value||'').toLowerCase().replace(/[^a-z0-9]/g,'');
  function matchApplication(app,selection){
    const missing=[];
    if(selection.year){
      const y=Number(selection.year), range=app.years;
      if(!range) missing.push('year');
      else if((range[0]!==null&&y<range[0])||y>range[1]) return null;
      else if(range[0]===null) missing.push('year');
    }
    for(const key of ['make','model']){
      if(selection[key]){
        if(!app[key]) missing.push(key);
        else if(app[key]!==selection[key]) return null;
      }
    }
    if(selection.engine){
      if(!app.engines?.length) missing.push('engine');
      else if(!app.engines.includes(selection.engine))return null;
    }
    return missing;
  }
  function matchProduct(product,selection){
    const c=product.catalog;
    if(!c||(selection.available&&!product.available))return null;
    if(selection.reference){
      const haystack=normalize([c.sku,c.oem,c.interchanges,product.sku].join(' '));
      if(!haystack.includes(normalize(selection.reference)))return null;
    }
    const vehicle=['year','make','model','engine'].some(k=>selection[k]);
    if(!vehicle)return {product,missing:[]};
    let best=null;
    for(const app of c.applications||[]){
      const missing=matchApplication(app,selection);
      if(missing!==null&&(!best||missing.length<best.length))best=missing;
    }
    return best===null?null:{product,missing:best};
  }
  const api={normalize,matchApplication,matchProduct};
  if(typeof module!=='undefined'&&module.exports)module.exports=api;
  else root.JTLFitmentCore=api;
})(typeof window==='undefined'?{}:window);
